/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from 'pinia';
import moment from 'moment';

export const useApplicationStore = defineStore('application', {
    state: () => ({
        loading: false
    }),
    getters: {
        isLoading: (state) => state.loading
    },
    actions: {
        setLoading(loading) {
            this.loading = loading;
        },
        formatDate(date) {
            return moment(date).format('DD.MM.YYYY HH:MM');
        }
    }
});
